var reservations = {
  options: {
    // global options
  },

  selectors: {
    list_item:        ".js-reservations-list-item",
    search:           ".js-reservations-search",
    search_button:    ".js-reservations-search-button",
    search_input:     ".js-reservations-search-input",
    search_not_found: ".js-reservations-search-not-found",
    search_reset:     ".js-reservations-search-reset",
  },

  init: function () {
    const self = this;

    self.loadFunctionInside();
  },

  loadFunctionInside: function () {
    const self = this;

    jQuery(self.selectors.search_button).on("click", function (event) {
      event.preventDefault();
      self.toggleSearch();
    });

    jQuery(self.selectors.search_reset).on("click", function (event) {
      event.preventDefault();
      self.toggleSearch(true);
    });

    jQuery(self.selectors.search_input).on("input", function (event) {
      self.search();
    });
  },

  toggleSearch: function (force_close = false) {
    const self = this;

    if (jQuery(self.selectors.search).hasClass("open") || force_close) {
      jQuery(self.selectors.search).removeClass("open");
      jQuery(self.selectors.search_input).val("").trigger("input");
    } else {
      jQuery(self.selectors.search).addClass("open");
      jQuery(self.selectors.search_input).trigger("focus");
    }
  },

  search: function () {
    const self = this;

    let search = self.normalizeText(jQuery(self.selectors.search_input).val().toLowerCase());

    if (search == "") {
      jQuery(self.selectors.list_item).removeClass("d-none");
      self.showMessageSearchNotFound();
      return;
    }
  
    jQuery(self.selectors.list_item).each(function () {
      let text = self.normalizeText(jQuery(this).find(".reservations__item-date").text().toLowerCase()) + " " + self.normalizeText(jQuery(this).find(".reservations__item-author").text().toLowerCase());
      //console.log(text);
  
      if (text.includes(search)) {
        jQuery(this).removeClass("d-none");
      } else {
        jQuery(this).addClass("d-none");
      }
    });

    self.showMessageSearchNotFound();
  },

  showMessageSearchNotFound: function () {
    const self = this;

    jQuery(self.selectors.search_not_found).removeClass("show");

    if (jQuery(self.selectors.list_item).length == 0) {
      return;
    }

    if (jQuery(self.selectors.list_item + ":not(.d-none)").length > 0) {
      return;
    }

    //show message
    jQuery(self.selectors.search_not_found).addClass("show");
  },

  normalizeText: function (text) {
    const self = this;

    return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  },
}

// Export
export { reservations };